export const PROVINCIACOD = "R";

/**
 * El nombre de la provincia, para las consultas de geocoding.
 *
 * El panel administra una sola provincia: las localidades se piden siempre con PROVINCIACOD y
 * las entidades guardan localidadId sin provincia. Pero Google si la necesita, porque los
 * nombres de localidad se repiten entre provincias: "San Antonio Oeste, Argentina" es unico,
 * "Chimpay, Argentina" tambien, pero "Los Menucos" o "General Roca" resuelven en mas de un
 * lugar del pais y sin la provincia el pin cae en la otra.
 */
export const PROVINCIA_NOMBRE = "Río Negro";
